module.exports = __webpack_public_path__ + "img/bg-blue.8100fb18.png";